<template>
  <div>
    <div class="made">
      <img :class="_isMobile ? 'bannerM' : 'bannerP'"
        :src="!_isMobile ? 'https://cdn.youjiajk.com/pc.png' : 'https://cdn.youjiajk.com/mobile.png'" />
    </div>
    <div :class="_isMobile ? '' : 'container'">
      <div :class="_isMobile ? 'titleM' : 'titleP'">网络食品交易第三方平台提供者备案信息表</div>
      <img class="containerImg" :src="!_isMobile ? 'https://cdn.youjiajk.com/internetFood.jpeg' : 'https://cdn.youjiajk.com/internetFood.jpeg'"/>
    </div>
  </div>
</template>

<script>
  export default {
    metaInfo() {
      return {
        meta: [{
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name: 'keywords',
            content: '优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false,
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
    }
  }
</script>

<style lang="less" scoped>
  .made {
    width: 100%;
    display: flex;
    flex-direction: column;

    .bannerM{
      width: 100%;
      height: 3rem;
    }
    .bannerP{
      width: 100%;
      height: 300px;
    }
    
  }
  .container{
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .containerImg{
    width: 100%;
  }
  .titleP {
      font-size: 30px;
      color: #333333;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      line-height: 42px;
      border-bottom: 1px solid rgba(151,151,151,0.5);
      padding-bottom: 37px;
      margin-bottom: 50px;
      margin-top: 40px;
  }
  .titleM {
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid rgba(151,151,151,0.5);
    padding-bottom: 0.37rem;
    margin: 0.4rem 0.75rem 0;
  }
</style>


// WEBPACK FOOTER //
// src/views/internetFood.vue